const iconProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.8,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const ApiIcon = () => (
  <svg {...iconProps}>
    <path d="M8.5 7 4 12l4.5 5M15.5 7 20 12l-4.5 5" />
  </svg>
);

export const DashboardIcon = () => (
  <svg {...iconProps}>
    <rect x="3.5" y="4.5" width="17" height="15" rx="2.5" />
    <path d="M3.5 9.5h17M9 9.5v10" />
  </svg>
);

export const SparkIcon = () => (
  <svg {...iconProps}>
    <path d="M12 3.5 13.7 9l5.5 1.7L13.7 12.4 12 18l-1.7-5.6L4.8 10.7 10.3 9 12 3.5Z" />
  </svg>
);

export const AskIcon = () => (
  <svg {...iconProps}>
    <path d="M4.5 5.5h15v10h-9l-4 4v-4h-2v-10Z" />
    <path d="M9 10.2l.9 1.9 1.9.9-1.9.9-.9 1.9-.9-1.9-1.9-.9 1.9-.9.9-1.9Z" />
  </svg>
);

export const StackIcon = () => (
  <svg {...iconProps}>
    <ellipse cx="12" cy="6" rx="7" ry="2.6" />
    <path d="M5 6v6c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6V6" />
    <path d="M5 12v6c0 1.4 3.1 2.6 7 2.6s7-1.2 7-2.6v-6" />
  </svg>
);

export const CrmIcon = () => (
  <svg {...iconProps}>
    <circle cx="9" cy="8.5" r="2.6" />
    <path d="M4 18.5a5 5 0 0 1 10 0" />
    <path d="M16 6.5a2.6 2.6 0 0 1 0 5" />
    <path d="M17.5 18.5a5 5 0 0 0-3-4.6" />
  </svg>
);
